export default __webpack_public_path__ + "static/media/icon-leads.9d89f25d.svg";